import { useMemo } from "react";
import { eachDayOfInterval } from "date-fns";
import _ from "lodash";

import { useGetAllActiveMerchantsIdAndNameCachedQuery, useGetAllCourierPartnersQuery, useGetAllDataUsingParallelRequestsBasedOnDateQuery } from "../../redux/commonApiCalls";
import { convertDate } from "../../helpers/UtilityHelper";
import { apiConstants } from "../../common/constants";

function useOverviewHook(opts) {
    const { dateRange, mode, shipmentType } = opts;

    const andfilter = [{ "field": "is_deleted", "operator": "eq", "value": '0' }];
    const filter = { andfilter, offset: 0, limit: 1000, skipCount: true, includes: "id,name,cpAccountCode,prozoId,supportedShipmentType,parent" };

    const { data: allCourier, isLoading, isFetching } = useGetAllCourierPartnersQuery(filter);
    const { data: allMerchants } = useGetAllActiveMerchantsIdAndNameCachedQuery();

    const request = useMemo(() => {
        if (dateRange?.length > 0) {
            return { from_date: convertDate(dateRange[0].startDate), to_date: convertDate(dateRange[0].endDate) };
        }
    }, [dateRange]);


    let awbRegUrl = null;

    if (mode === 'overall') {
        awbRegUrl = apiConstants.DASHBOARD_CONTROLTOWER_DATEWISE_AWB_REGISTERED;
    } else if (mode === 'overall_today') {
        awbRegUrl = apiConstants.DASHBOARD_CONTROLTOWER_DATEWISE_AWB_REGISTERED_TODAY;
    } else if (mode === 'realised') {
        awbRegUrl = apiConstants.DASHBOARD_CONTROLTOWER_DATEWISE_DELIVERED;
    }

    const getRegisteredShipmentPayload = { method: 'GET', url: awbRegUrl, payload: { ...request, shipmentType_list: shipmentType } };
    const getRtoShipmentPayload = { method: 'GET', url: apiConstants.DASHBOARD_CONTROLTOWER_DATEWISE_RTO_DELIVERED, payload: { ...request, shipmentType_list: shipmentType } };

    let { data: awbRegisteredData = [], isLoading: isLoadingAwb, isFetching: isFetchingAwb } = useGetAllDataUsingParallelRequestsBasedOnDateQuery(getRegisteredShipmentPayload);
    let { data: rtoData = [], isLoading: isLoadingRto, isFetching: isFetchingRto } = useGetAllDataUsingParallelRequestsBasedOnDateQuery(getRtoShipmentPayload, { skip: mode === "overall" || mode === "overall_today" });

    if (isLoadingAwb || isFetchingAwb || isLoadingRto || isFetchingRto) {
        return { loading: true }
    }

    let dashboardData = [],
        shipmentCountData = [],
        shipmentCountDataCourier = [],
        dashboardDataCourier = [];


    const eachDay = eachDayOfInterval({ start: dateRange[0].startDate, end: dateRange[0].endDate })
    const eachDayBetween = eachDay.map(day => convertDate(day))

    console.log(awbRegisteredData)
    // create merchant wise date wise object
    for (let i = 0; i < awbRegisteredData.length; i++) {
        for (let j = 0; j < awbRegisteredData[i].data.length; j++) {
            let merchant = awbRegisteredData[i].data[j]._id.merchant
            let itemShipmentType = awbRegisteredData[i].data[j]._id.shipmentType || ''
            let itemOrderType = awbRegisteredData[i].data[j]._id.orderType || ''
            for (let k = 0; k < awbRegisteredData[i].data[j].data.length; k++) {
                let obj = {};
                obj.merchant = merchant;
                obj.shipmentType = itemShipmentType;
                obj.orderType = itemOrderType;
                let status = awbRegisteredData[i].data[j].data[k]?.orderStatus;
                if (status && status !== 'CANCELLED_ORDER') {
                    obj.revenue = awbRegisteredData[i].data[j].data[k].price === undefined ? 0 : parseFloat(awbRegisteredData[i].data[j].data[k].price)
                    if (mode === "overall" || mode === "overall_today") {
                        obj.date = convertDate(awbRegisteredData[i].data[j].data[k].awbRegisteredDate)
                    } else {
                        obj.date = convertDate(awbRegisteredData[i].data[j].data[k].actualDeliveryTime)
                    }
                    dashboardData.push(obj)
                    shipmentCountData.push(obj)
                    }
                }
        }
    }
    console.log(dashboardData)
    for (let i = 0; i < rtoData.length; i++) {
        for (let j = 0; j < rtoData[i].data.length; j++) {
            let merchant = rtoData[i].data[j]._id.merchant
            for (let k = 0; k < rtoData[i].data[j].data.length; k++) {
                let obj = {};
                obj.merchant = merchant;
                let rtoRevenue = rtoData[i].data[j].data[k].priceRTO === undefined ? 0 : parseFloat(rtoData[i].data[j].data[k].priceRTO);
                let forwardRevenue = rtoData[i].data[j].data[k].price === undefined ? 0 : parseFloat(rtoData[i].data[j].data[k].price);
                //obj.revenueRTO = rtoRevenue + forwardRevenue
                //obj.revenueRTO = 0
                if (mode === "overall" || mode === "overall_today") {
                    obj.revenueRTO = 0
                } else {
                    obj.revenueRTO = rtoRevenue + forwardRevenue
                }
                obj.date = convertDate(rtoData[i].data[j].data[k].rtoDeliveredTimestamp)
                dashboardData.push(obj)
            }
        }
    }

    const merchantDataGroupedByDate = _(dashboardData)
        .groupBy('merchant')
        .map((merchantObjs, merchant) => {
            const merchantNameObj = _.find(allMerchants, { id: merchant });
            if (!merchantNameObj) {
                return null; // Ignore the row if merchantNameObj is null
            }
            const merchantName = merchantNameObj.name;

            /* rowKey: the id this row was grouped by. The grid needs a unique row identity and the
               display name is not one — several merchant/courier ids can resolve to the same name.
               Not a rendered column, so it does not reach the Excel export. */
            const merchantObject = {
                rowKey: merchant,
                merchantName: merchantName,
            };

            let merchantTotal = 0;

            _.forEach(merchantObjs, ({ date, revenue, revenueRTO }) => {
                const totalRevenue = (_.toNumber(revenue) || 0) + (_.toNumber(revenueRTO) || 0);
                merchantObject[date] = _.has(merchantObject, date)
                    ? merchantObject[date] + totalRevenue
                    : totalRevenue;
                merchantTotal += totalRevenue;
            });

            merchantObject.total = merchantTotal;
            return merchantObject;
        })
        .filter(obj => obj !== null)
        .value();

    const totalsRow = { rowKey: "Totals", "merchantName": "Totals" };
    eachDayBetween.forEach(date => {
        const totalRevenue = _.sumBy(merchantDataGroupedByDate, date);
        totalsRow[date] = totalRevenue;
    });

    /* Sum the rows' own totals, NOT the in-range date columns built just above.
​
       Each row buckets its records by whatever date the record carries, and its `total` counts
       every one of them. The date columns only cover the SELECTED range, so a record dated
       outside it (orders either side of midnight — convertDate resolves the timestamp in browser
       local time, which need not agree with the window the API used) lands in a bucket that has
       no column. Summing the columns therefore missed exactly those records, so the Totals row
       came out lower than the rows above it — visible on prod as a courier showing 2,223 in TOTAL
       against 2,214 in its only date column, while Totals showed no gap at all.

       Sum-of-rows is the honest figure and matches a raw order export. Note the rows' totals will
       still exceed the sum of their VISIBLE columns; the out-of-range records are counted but not
       shown, which is a separate (and larger) change to the column set. */
    totalsRow.total = _.sumBy(merchantDataGroupedByDate, 'total');
    merchantDataGroupedByDate.unshift(totalsRow)
    // end create merchant wise date wise data

    // create courier wise date wise object
    for (let i = 0; i < awbRegisteredData.length; i++) {
        for (let j = 0; j < awbRegisteredData[i].data.length; j++) {
            let courier = awbRegisteredData[i].data[j]._id.courier
            for (let k = 0; k < awbRegisteredData[i].data[j].data.length; k++) {
                let obj = {};
                obj.courier = courier;
                obj.revenue = awbRegisteredData[i].data[j].data[k].price === undefined ? 0 : parseFloat(awbRegisteredData[i].data[j].data[k].price)
                let status = awbRegisteredData[i].data[j].data[k]?.orderStatus;
                if (status && status !== 'CANCELLED_ORDER') {
                    if (mode === "overall" || mode === "overall_today") {
                        obj.date = convertDate(awbRegisteredData[i].data[j].data[k].awbRegisteredDate)
                    } else {
                        obj.date = convertDate(awbRegisteredData[i].data[j].data[k].actualDeliveryTime)
                    }
                }
                dashboardDataCourier.push(obj)
                shipmentCountDataCourier.push(obj)
            }
        }
    }

    for (let i = 0; i < rtoData.length; i++) {
        for (let j = 0; j < rtoData[i].data.length; j++) {
            let courier = rtoData[i].data[j]._id.courier
            for (let k = 0; k < rtoData[i].data[j].data.length; k++) {
                let obj = {};
                obj.courier = courier;
                let rtoRevenue = rtoData[i].data[j].data[k].priceRTO === undefined ? 0 : parseFloat(rtoData[i].data[j].data[k].priceRTO);
                let forwardRevenue = rtoData[i].data[j].data[k].price === undefined ? 0 : parseFloat(rtoData[i].data[j].data[k].price);
                obj.revenueRTO = rtoRevenue + forwardRevenue;
                obj.date = convertDate(rtoData[i].data[j].data[k].rtoDeliveredTimestamp)
                dashboardDataCourier.push(obj)
            }
        }
    }

    const courierDataGroupedByDate = _(dashboardDataCourier)
        .groupBy('courier')
        .map((courierObjs, courier) => {
            const courierNameObj = _.find(allCourier, { id: courier });
            const courierName = courierNameObj?.name || courierNameObj?.cpAccountCode || `Courier-${String(courier).slice(-6)}`;

            /* rowKey: the id this row was grouped by. The grid needs a unique row identity and the
               display name is not one — several merchant/courier ids can resolve to the same name.
               Not a rendered column, so it does not reach the Excel export. */
            const courierObject = {
                rowKey: courier,
                courierName: courierName,
            };

            let courierTotal = 0;
            _.forEach(courierObjs, ({ date, revenue, revenueRTO }) => {
                const totalRevenue = (_.toNumber(revenue) || 0) + (_.toNumber(revenueRTO) || 0);
                courierObject[date] = _.has(courierObject, date)
                    ? courierObject[date] + totalRevenue
                    : totalRevenue;
                courierTotal += totalRevenue;
            });

            courierObject.total = courierTotal;
            return courierObject;
        })
        .value();

    const totalsRowCourier = {
        rowKey: "Totals",
        "courierName": "Totals",
    };

    //const dates1 = _.keys(_.omit(courierDataGroupedByDate[0], ["courierName", "total"]));
    eachDayBetween.forEach(date1 => {
        const totalRevenue = _.sumBy(courierDataGroupedByDate, date1);
        totalsRowCourier[date1] = totalRevenue;
    });

    // Sum-of-rows, for the reason spelled out on the merchant revenue Totals row above.
    totalsRowCourier.total = _.sumBy(courierDataGroupedByDate, 'total');
    courierDataGroupedByDate.unshift(totalsRowCourier)

    // END - create courier wise date wise object

    // create merchant wise shipment count data
    const isRvpType = (type) => {
        if (!type) return false;
        const t = String(type).toUpperCase();
        return t.includes('RVP') || t.includes('REVERSE');
    };

    const merchantShipmentCountDataGroupedByDate = _(shipmentCountData)
        .groupBy('merchant')
        .map((merchantObjs, merchant) => {
            const merchantNameObj = _.find(allMerchants, { id: merchant });
            if (!merchantNameObj) {
                return null; // Ignore the row if merchantNameObj is null
            }
            const merchantName = merchantNameObj.name;
            /* rowKey: the id this row was grouped by. The grid needs a unique row identity and the
               display name is not one — several merchant/courier ids can resolve to the same name.
               Not a rendered column, so it does not reach the Excel export. */
            const merchantObject = {
                rowKey: merchant,
                merchantName: merchantName,
            };

            let merchantTotal = 0;
            let forwardCount = 0;
            let rvpCount = 0;
            _.forEach(merchantObjs, ({ date, orderType }) => {
                if (_.has(merchantObject, date)) {
                    merchantObject[date] += 1;
                } else {
                    merchantObject[date] = 1;
                }
                merchantTotal += 1;
                if (isRvpType(orderType)) {
                    rvpCount += 1;
                } else {
                    forwardCount += 1;
                }
            });
            merchantObject.total = merchantTotal;
            merchantObject.forwardCount = forwardCount;
            merchantObject.rvpCount = rvpCount;
            return merchantObject;
        })
        .filter(obj => obj !== null)
        .value();

    const totalsRowMerchantCount = {
        rowKey: "Totals",
        "merchantName": "Totals",
    };


    eachDayBetween.forEach(date => {
        const totalCount = _.sumBy(merchantShipmentCountDataGroupedByDate, date);
        totalsRowMerchantCount[date] = totalCount;
    });

    /* Sum-of-rows, for the reason on the merchant revenue Totals row above — and this is the one
       that drives the "Total Shipments" KPI card. It also settles a visible contradiction on this
       very row: forwardCount and rvpCount below were ALREADY summed from the rows (so they counted
       every record), while total summed the in-range columns only. FWD + RVP therefore did not add
       up to SHIPMENTS on the Totals row, even though it did on every merchant row. */
    totalsRowMerchantCount.total = _.sumBy(merchantShipmentCountDataGroupedByDate, 'total');
    totalsRowMerchantCount.forwardCount = _.sumBy(merchantShipmentCountDataGroupedByDate, 'forwardCount');
    totalsRowMerchantCount.rvpCount = _.sumBy(merchantShipmentCountDataGroupedByDate, 'rvpCount');
    merchantShipmentCountDataGroupedByDate.unshift(totalsRowMerchantCount)


    // create courier wise shipment count data
    const courierShipmentCountDataGroupedByDate = _(shipmentCountDataCourier)
        .groupBy('courier')
        .map((courierObjs, courier) => {
            const courierNameObj = _.find(allCourier, { id: courier });
            const courierName = courierNameObj?.name || courierNameObj?.cpAccountCode || `Courier-${String(courier).slice(-6)}`;
            /* rowKey: the id this row was grouped by. The grid needs a unique row identity and the
               display name is not one — several merchant/courier ids can resolve to the same name.
               Not a rendered column, so it does not reach the Excel export. */
            const courierObject = {
                rowKey: courier,
                courierName: courierName,
                parent: courierNameObj?.parent || courierName, // courier-partner parent (for parent-level rollups)
            };

            let courierTotal = 0;
            _.forEach(courierObjs, ({ date }) => {
                if (_.has(courierObject, date)) {
                    courierObject[date] += 1; // Increment the count of shipments for each date
                } else {
                    courierObject[date] = 1; // Start the count at 1 for each date
                }
                courierTotal += 1; // Increment the total count of shipments
            });
            courierObject.total = courierTotal;
            return courierObject;
        })
        .value();
    const totalsRowCourierCount = {
        rowKey: "Totals",
        "courierName": "Totals",
    };

    eachDayBetween.forEach(date => {
        const totalCount = _.sumBy(courierShipmentCountDataGroupedByDate, date);
        totalsRowCourierCount[date] = totalCount;
    });
    // Sum-of-rows, for the reason spelled out on the merchant revenue Totals row above.
    totalsRowCourierCount.total = _.sumBy(courierShipmentCountDataGroupedByDate, 'total');
    courierShipmentCountDataGroupedByDate.unshift(totalsRowCourierCount)

    return {
        loading: false,
        finalMerchantDateData: merchantDataGroupedByDate,
        finalCourierDateData: courierDataGroupedByDate,
        finalMerchantShipmentCountData: merchantShipmentCountDataGroupedByDate,
        finalCourierShipmentCountData: courierShipmentCountDataGroupedByDate
    }
}

export default useOverviewHook;